import { Box } from "../../../../components";
import { usePublicDocumentInfo } from "../../../document/hooks/published-documents/use-public-documents-info";
import { ColumnsType } from "antd/es/table";
import { Col, Row, Table } from "antd";
import moment from "moment";
import { DateFormat } from "../../../../constants";
import { isGUID } from "../../../document/util";
import { DocumentStatisticByUserChart } from "../DocumentStatisticByUserChart";

export const StatisticDistributionDocumentPage = () => {
  const { finalReadUser, data } = usePublicDocumentInfo();

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      key: "index",
      dataIndex: "index",
      align: "center" as const,
    },
    {
      title: "Mã nhân viên",
      key: "employeeId",
      dataIndex: "employeeId",
      width: 150,
      render: (id) => (!isGUID(id) ? id : ""),
    },
    {
      title: "Họ và tên",
      key: "employeeName",
      dataIndex: "employeeName",
    },
    {
      title: "Phòng ban",
      key: "department",
      dataIndex: "department",
    },
    {
      title: "Đơn vị",
      key: "pDeptCode",
      dataIndex: "pDeptCode",
    },
    {
      title: "Đã đọc",
      key: "read",
      dataIndex: "read",
      render: (read) => (read ? "✅" : ""),
      align: "center" as const,
      width: 100,
    },
    {
      title: "Chưa đọc",
      key: "read",
      dataIndex: "read",
      render: (read) => (read ? "" : "❌"),
      align: "center" as const,
      width: 100,
    },
    {
      title: "Ghi chú",
      key: "dateRead",
      dataIndex: "dateRead",
    },
  ];

  return data ? (
    <Box title="Danh sách đơn vị/cá nhân nhận tài liệu.">
      <Row>
        <Col sm={8} md={8}>
          <p>- Tên tài liệu/CV/CS: {data?.Title}</p>
          <p>- Lần sửa đổi: {data?.docEditionVersion}</p>
          <p>- Lần ban hành: {data?.docPublishViewVersion}</p>
          <p>- Thời gian chiết xuất dữ liệu: {moment().format(DateFormat.DD_MM_YYYY_HH_MM)}</p>
          <p>- Tổng số nhân viên được triển khai: {finalReadUser.length}</p>
        </Col>
        <Col sm={16} md={16}>
          <div>
            <DocumentStatisticByUserChart />
          </div>
        </Col>
      </Row>
      <Table columns={columns} dataSource={finalReadUser} />
    </Box>
  ) : (
    <></>
  );
};
